<cerrix-dialog [name]="name" [attr.data-uiid]="dataUiid">
    <div header-title>
        <span>
            @if (openReason === OpenAddHyperlinkDialogReason.Add) {
                {{ "titleAdd" | t }}
            } @else if (openReason === OpenAddHyperlinkDialogReason.Edit) {
                {{ "titleEdit" | t }}
            } @else if (openReason === OpenAddHyperlinkDialogReason.View) {
                {{ "titleView" | t }}
            }
        </span>
    </div>
    <div class="add-hyperlink-dialog-content" dialog-content>
        <div class="name-and-hyperlinktype">
            <cerrix-input-group
                [name]="'hyperlink-name'"
                appValidationRequired
                [infoText]="'nameInfo' | t"
                [placeholder]="'namePlaceholder' | t"
                [value]="editHyperlink?.name ?? ''"
                (valueChange)="editHyperlink.name = $event"
            >
                {{ "nameLabel" | t }}
            </cerrix-input-group>
            <app-cerrix-select-group
                name="asset-hyperlinktype"
                [options]="hyperlinkTypeOptions"
                [infoText]="'hyperlinkTypeInfo' | t"
                [placeholder]="'hyperlinkTypePlaceholder' | t"
                [selectedValue]="editHyperlink?.hyperlinkType"
                (selectionChange)="onHyperlinkTypeChange($event)"
            >
                {{ "hyperlinkTypeLabel" | t }}
            </app-cerrix-select-group>
        </div>
        <app-cerrix-hyperlink-url-input-group
            [name]="'hyperlink-url'"
            appValidationRequired
            [value]="editHyperlink?.hyperlinkUrl ?? ''"
            (valueChange)="onHyperlinkUrlChange($event)"
            [infoText]="'hyperlinkUrlInfo' | t"
            [placeholder]="'hyperlinkUrlPlaceholder' | t"
        >
            {{ "hyperlinkUrlLabel" | t }}
        </app-cerrix-hyperlink-url-input-group>
        <cerrix-textarea-group
            [name]="'hyperlink-description'"
            [textareaDialogTitle]="
                'hyperlinkDescriptionLabel' | t
            "
            [placeholder]="
                'hyperlinkDescriptionPlaceholder' | t
            "
            [rows]="5"
            [value]="editHyperlink?.description ?? ''"
            (valueChange)="onHyperlinkDescriptionChange($event)"
        >
            {{ "hyperlinkDescriptionLabel" | t }}
        </cerrix-textarea-group>
    </div>
    <div class="add-hyperlink-dialog-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            (click)="cancelDialog.emit(hyperlink)"
            [attr.data-uiid]="dataUiid + '--cancel'"
            >{{ "cancel" | t }}</cerrix-button
        >
        @if (openReason !== OpenAddHyperlinkDialogReason.View) {
            <cerrix-button
                buttonSize="big"
                primaryColor="green"
                (click)="saveHyperlink()"
                [attr.data-uiid]="dataUiid + '--confirm'"
            >
                @if (openReason === OpenAddHyperlinkDialogReason.Add) {
                    {{ "confirmAddHyperlink" | t }}
                } @else if (openReason === OpenAddHyperlinkDialogReason.Edit) {
                    {{ "confirmEditHyperlink" | t }}
                }
            </cerrix-button>
        }
    </div>
</cerrix-dialog>
